<template>
  <!-- nbiot_cab_line_check_2w but <> 1STW-1MCB-1PW-1MC-2CB-1TFM 4G -->
  <b-row
    v-if="sem_type == 'nbiot_cab_line_check_2w' && diagram_type !== '1STW-1MCB-1PW-1MC-2CB-1TFM' && $route.query.type === 'iot4g'"
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 38px">สายไฟด้านซ้าย</span><br><br><br>
      <!-- <b-img
        class="mt-1"
        :src="require('@/assets/images/icons/semcontrol/diagram/leftwire.svg')"
        style="height: 60%; width: auto;"
      /> -->
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/leftwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 38px">สายไฟด้านขวา</span><br><br><br>
      <!-- <b-img
        class="mt-1"
        :src="require('@/assets/images/icons/semcontrol/diagram/rightwire.svg')"
        style="height: 60%; width: auto;"
      /> -->
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/rightwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="(check.line_detect_fail_left === 0)"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-if="(check.line_detect_fail_left === 1)"
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="(check.line_detect_fail_right === 0)"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-if="(check.line_detect_fail_right === 1)"
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row>
  <!-- nbiot_cab_line_check_2w 67 -->
  <b-row
    v-else-if="$route.query.type === 'iot4g-67' && !['nbiot_cab_line_check_1w_r', 'nbiot_cab_line_check_1w_l'].includes(sem_type)"
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 38px">สายไฟด้านซ้าย</span><br><br><br>
      <!-- <b-img
        class="mt-1"
        :src="require('@/assets/images/icons/semcontrol/diagram/leftwire.svg')"
        style="height: 60%; width: auto;"
      /> -->
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/leftwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 38px">สายไฟด้านขวา</span><br><br><br>
      <!-- <b-img
        class="mt-1"
        :src="require('@/assets/images/icons/semcontrol/diagram/rightwire.svg')"
        style="height: 60%; width: auto;"
      /> -->
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/rightwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      class="mt-1"
      lg="6"
    >
      <b-img
        v-if="(check.line_detect1 !== 'OK' && check.line_detect2 !== 'OK')"
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else-if="(check.line_detect1 === 'OK' || check.line_detect2 === 'OK')"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="(check.line_detect3 === 'OK' || check.line_detect4 === 'OK')"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else-if="(check.line_detect3 !== 'OK' && check.line_detect4 !== 'OK')"
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row>
  <!-- nbiot_cab_line_check_1w_r 67 -->
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_1w_r' && $route.query.type === 'iot4g-67'"
    class="text-center"
  >
    <b-col
      cols="12"
    >
      <b-img
        :src="require('@/assets/images/icons/semcontrol/diagram/rightwire.png')"
        style="height: auto; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="12"
    >
      <b-img
        v-if="(check.line_detect1 === 'OK' && check.line_detect2 === 'OK')"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 70%; width: 70%;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 70%; width: 70%;"
      />
    </b-col>
  </b-row>
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_2w' && diagram_type !== '1STW-1MCB-1PW-1MC-2CB-1TFM' && $route.query.type !== 'iot4g' && double_check === 0"
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านซ้าย</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/leftwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านขวา</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/rightwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="check.line_detect1 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="check.line_detect2 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row>
  <!-- nbiot_cab_line_check_1w_l 67 -->
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_1w_l' && $route.query.type === 'iot4g-67'"
    class="text-center"
  >
    <b-col
      cols="12"
    >
      <b-img
        :src="require('@/assets/images/icons/semcontrol/diagram/rightwire.png')"
        style="height: auto; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="12"
    >
      <b-img
        v-if="(check.line_detect1 === 'OK' && check.line_detect2 === 'OK')"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 70%; width: 70%;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 70%; width: 70%;"
      />
    </b-col>
  </b-row>
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_2w' && diagram_type !== '1STW-1MCB-1PW-1MC-2CB-1TFM' && $route.query.type !== 'iot4g' && double_check === 0"
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านซ้าย</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/leftwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านขวา</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/rightwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="check.line_detect1 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="check.line_detect2 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row>
  <!-- nbiot_cab_line_check_4w AND 1STW-1MCB-1PW-1MC-4CB-1TFM ยังไม่ if 4G -->
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_4w' && diagram_type === '1STW-1MCB-1PW-1MC-4CB-1TFM' && $route.query.type !== 'iot4g'"
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านซ้าย</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/leftwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านขวา</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/rightwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect1 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect2 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect3 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect4 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row>
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_4w' && diagram_type === '1STW-1MCB-1PW-1MC-4CB-1TFM' && $route.query.type === 'iot4g'"
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านซ้าย</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/leftwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านขวา</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/rightwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect1 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect2 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect3 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect4 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row>
  <!-- <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_4w' && diagram_type === '1STW-1MCB-1PW-1MC-4CB-1TFM' && $route.query.type === 'iot4g' "
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านซ้าย</span><br>
      <b-img
        class="mt-1"
        :src="require('@/assets/images/icons/semcontrol/diagram/leftwire.svg')"
        style="height: auto; width: auto;"
      />
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านขวา</span><br>
      <b-img
        class="mt-1"
        :src="require('@/assets/images/icons/semcontrol/diagram/rightwire.svg')"
        style="height: auto; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect1 === 'OK' && check.line_detect2 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect3 === 'OK' && check.line_detect4 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect5 === 'OK' && check.line_detect6 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="3"
    >
      <b-img
        v-if="check.line_detect7 === 'OK' && check.line_detect8 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row> -->
  <!-- nbiot_cab_line_check_2w AND 1STW-1MCB-1PW-1MC-2CB-1TFM 4G-->
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_2w' && diagram_type === '1STW-1MCB-1PW-1MC-2CB-1TFM' && $route.query.type !== 'iot4g' && double_check === 0"
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านซ้าย</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/leftwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านขวา</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/rightwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="check.line_detect1 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="check.line_detect2 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row>
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_2w' && diagram_type === '1STW-1MCB-1PW-1MC-2CB-1TFM' && $route.query.type === 'iot4g'"
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านซ้าย</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/leftwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านขวา</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/rightwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="(check.line_detect_fail_left === 0)"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-if="(check.line_detect_fail_left === 1)"
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="(check.line_detect_fail_right === 0)"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-if="(check.line_detect_fail_right === 1)"
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row>
  <!-- nbiot_cab_line_check_1w_r AND 1STW-1MCB-1PW-1MC-2CB-1TFM 4G-->
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_1w_r' && diagram_type === '1STW-1MCB-1PW-1MC-2CB-1TFM' && $route.query.type !== 'iot4g'"
    class="text-center"
  >
    <b-col
      cols="12"
    >
      <b-img
        :src="require('@/assets/images/icons/semcontrol/diagram/rightwire.svg')"
        style="height: auto; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="12"
    >
      <b-img
        v-if="check.line_detect2 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 80%; width: 80%;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 80%; width: 80%;"
      />
    </b-col>
  </b-row>
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_1w_r' && diagram_type === '1STW-1MCB-1PW-1MC-2CB-1TFM' && $route.query.type === 'iot4g'"
    class="text-center"
  >
    <b-col
      cols="12"
    >
      <b-img
        :src="require('@/assets/images/icons/semcontrol/diagram/rightwire.svg')"
        style="height: auto; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="12"
    >
      <b-img
        v-if="(check.line_detect_fail_right === 0)"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 80%; width: 80%;"
      />
      <b-img
        v-if="(check.line_detect_fail_right === 1)"
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 80%; width: 80%;"
      />
    </b-col>
  </b-row>
  <!-- nbiot_cab_line_check_1w_r AND 0STW-1MCB-1PW-1MC-1CB-1TFM 4G-->
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_1w_r' && diagram_type === '0STW-1MCB-1PW-1MC-1CB-1TFM' && $route.query.type !== 'iot4g'"
    class="text-center"
  >
    <b-col
      cols="12"
    >
      <b-img
        :src="require('@/assets/images/icons/semcontrol/diagram/rightwire.svg')"
        style="height: auto; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="12"
    >
      <b-img
        v-if="check.line_detect2 === 'OK'"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 80%; width: 80%;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 80%; width: 80%;"
      />
    </b-col>
  </b-row>
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_1w_r' && diagram_type === '0STW-1MCB-1PW-1MC-1CB-1TFM' && $route.query.type === 'iot4g'"
    class="text-center"
  >
    <b-col
      cols="12"
    >
      <b-img
        :src="require('@/assets/images/icons/semcontrol/diagram/rightwire.svg')"
        style="height: auto; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="12"
    >
      <b-img
        v-if="(check.line_detect_fail_right === 0)"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 80%; width: 80%;"
      />
      <b-img
        v-if="(check.line_detect_fail_right === 1)"
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 80%; width: 80%;"
      />
    </b-col>
  </b-row>
  <!-- nbiot_cab_line_check_1w_l AND 0STW-1MCB-1PW-1MC-1CB-1TFM-1w_l 4G-->
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_1w_l' && diagram_type === '0STW-1MCB-1PW-1MC-2CB-1TFM' && $route.query.type === 'iot4g'"
    class="text-center"
  >
    <b-col
      cols="12"
    >
      <b-img
        :src="require('@/assets/images/icons/semcontrol/diagram/rightwire.svg')"
        style="height: auto; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="12"
    >
      <b-img
        v-if="(check.line_detect_fail_left === 0)"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 80%; width: 80%;"
      />
      <b-img
        v-if="(check.line_detect_fail_left === 1)"
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 80%; width: 80%;"
      />
    </b-col>
  </b-row>
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_1w_l' && diagram_type === '0STW-1MCB-1PW-1MC-1CB-1TFM' && $route.query.type === 'iot4g-67'"
    class="text-center"
  >
    <b-col
      cols="12"
    >
      <b-img
        :src="require('@/assets/images/icons/semcontrol/diagram/leftwire.png')"
        style="height: auto; width: 50%;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="12"
    >
      <b-img
        v-if="(check.line_detect1 === 'OK')"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 70%; width: 70%;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 70%; width: 70%;"
      />
    </b-col>
  </b-row>
  <!-- double_check AND 0STW-1MCB-1PW-1MC-2CB-1TFM-2w-->
  <!-- <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_2w' && diagram_type !== '1STW-1MCB-1PW-1MC-2CB-1TFM' && $route.query.type !== 'iot4g' && double_check === 1"
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านซ้าย</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/leftwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านขวา</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/rightwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      class="mt-2"
      cols="6"
    >
      <b-img
        v-if="items.line_detect1 === 1 || items.line_detect2 === 1"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-2"
      cols="6"
    >
      <b-img
        v-if="items.line_detect3 === 1 || items.line_detect4 === 1"
        :src="require('@/assets/images/icons/semcontrol1/normal3.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol1/abnormal3.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row> -->
  <!-- nbiot_cab_line_check_2w AND 1STW-1MCB-1PW-1MC-2CB-1TFM NBIOT DOUBLE-CHECK-->
  <b-row
    v-else-if="sem_type == 'nbiot_cab_line_check_2w' && $route.query.type !== 'iot4g' && double_check === 1"
    class="text-center"
  >
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านซ้าย</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/leftwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      cols="6"
    >
      <span style="font-size: 36px">สายไฟด้านขวา</span><br><br><br>
      <span style="font-size: 48px; color: rgb(238, 238, 0);">
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/rightwireicon.png')"
          style="height: 100px; width: auto;"
        /> สถานะ :</span>
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="items.line_detect1 === 1 || items.line_detect2 === 1"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
    <b-col
      class="mt-1"
      cols="6"
    >
      <b-img
        v-if="items.line_detect3 === 1 || items.line_detect4 === 1"
        :src="require('@/assets/images/icons/semcontrol/diagram/normal.svg')"
        style="height: 100%; width: auto;"
      />
      <b-img
        v-else
        :src="require('@/assets/images/icons/semcontrol/diagram/abnormal.svg')"
        style="height: 100%; width: auto;"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import axios from '@axios'
// import AppEchartBar from './AppEchartBar.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    // BButton,
  },
  data() {
    return {
      check: [],
      checkLeft: '',
      checkRight: '',
      statisticTitle: '',
      Total: '',
      sem_type: '',
      diagram_type: '',
      color: '#00B058',
      items: [],
      ampPhase1: [],
      double_check: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.checkLine()
    this.getValueDiagram()
    setInterval(this.getNow, 1000)
    this.interval = setInterval(() => {
      this.checkLine()
      this.getValueDiagram()
    }, 10000)
  },
  mounted() {
  },
  methods: {
    checkLine() {
      axios.post('/checkLine', { wid: this.$route.query.wid })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.check = response.data[0]
          this.sem_type = response.data[0].sem_type
          if (this.check.line_detect1 === 'OK') {
            this.checkLeft = 'normal'
          } else {
            this.checkLeft = 'abnormal'
          }
          if (this.check.line_detect2 === 'OK') {
            this.checkLeft = 'normal'
          } else {
            this.checkLeft = 'abnormal'
          }
          if (this.check.line_detect3 === 'OK') {
            this.checkRight = 'normal'
          } else {
            this.checkRight = 'abnormal'
          }
          if (this.check.line_detect4 === 'OK') {
            this.checkRight = 'normal'
          } else {
            this.checkRight = 'abnormal'
          }
          if (this.check.line_detect5 === 'OK') {
            this.checkRight = 'normal'
          } else {
            this.checkRight = 'abnormal'
          }
          if (this.check.line_detect6 === 'OK') {
            this.checkRight = 'normal'
          } else {
            this.checkRight = 'abnormal'
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getValueDiagram() {
      axios
        .post('/valueDiagram', { wid: this.$route.query.wid })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.items = response.data[0]
          this.diagram_type = response.data[0].diagram_type
          this.double_check = response.data[0].client_double_check
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

  <style lang="scss" scpoed>
    .text1 {
      position: absolute;
      font-family: Arial;
      top: 20px;
      right: 20px;
      color: white;
    }
    .round-button {
    min-width: 50px;
    height: 50px;
    border-style: none;
    border-radius: 50%;
    text-align: center;
    padding: 0;
    color: white;
    line-height: 20px; // to center text vertically
  }
    </style>
